import { StyledAuctionText } from 'modules/BuyerActivity/VehicleAuction.styled'
import { useContext } from 'react'
import { VehicleContext } from './VehicleContext'
import { normalizeCurrencySymbol } from 'utils/currencyUtils'

export const UserMaxBid = () => {
  const {
    vehicleData: { auctionInfo }
  } = useContext(VehicleContext)

  return (
    <>
      {auctionInfo?.CanBid && auctionInfo.UserMaxBid !== 0 && (
        <StyledAuctionText>
          <span>Your Max Bid: </span>
          {normalizeCurrencySymbol(auctionInfo.UserMaxBidString)}
        </StyledAuctionText>
      )}
    </>
  )
}
